import { supabaseClient } from "@/lib/supabase";
import type { Shockwave } from "@/types/database/events";
import type { UuidT } from "@/types/zod/auth";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { createGetDiaryKey } from "../../diaries/api";
import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";

export async function upsertShockwave(shockwave: Shockwave["Insert"]) {
	const { data, error } = await supabaseClient
		.from("shockwaves")
		.upsert(shockwave)
		.select()
		.single();
	if (error) throw error;
	return data;
}

interface shockwaveMutation {
	diaryId: UuidT;
}

export const useShockwaveMutation = ({ diaryId }: shockwaveMutation) => {
	const invalidateDiaries = useInvalidateDiaries();
	return useMutation({
		mutationKey: ["shockwave"],
		mutationFn: async (data: Shockwave["Insert"]) => {
			return await upsertShockwave(data);
		},
		onError: (error) => {
			toast.error(error.message);
		},
		onSuccess: () => {
			toast.success("Diary shockwave saved");
		},
		onSettled: () => {
			invalidateDiaries(diaryId);
		},
	});
};
